import styled from "styled-components";

export const FileList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

export const FileItem = styled.li`
  display: block;
  width: 100%;
  padding: 5px;
  box-sizing: border-box;
`;
